"use client"

import {
    Flex,
    Spin
} from "antd";
import { useTranslations } from "next-intl";
import s from './wallets.module.scss';
import { useApi } from "@/lib/hook";
import { WalletIcon } from "@/theme/assets/icons";


export const WalletsComponent = () => {
    const t = useTranslations('wallet');
    const { data: data, isFetching } = useApi({
        route: {
            name: 'wallets.all',
        },
        setting: {
            select: (resp) => resp,
        },
    });

    return (
        <div
            className={s.block}
        >
            <Spin spinning={isFetching}>
                <Flex
                    justify={'space-between'}
                    align={'center'}
                >
                    <Flex
                        align={'center'}
                        gap={16}
                    >
                        <WalletIcon />
                        <span
                            className={s.title}
                        >
                            {t('your_wallets')}
                        </span>
                    </Flex>
                    <div
                        className={s.right}
                    >
                        <span
                            className={s.available}
                        >
                            {t('available')}
                        </span>
                        <Flex
                            justify={'space-between'}
                            gap={24}
                        >
                            {data?.map((item, i) => (
                                <div
                                    key={i}
                                >
                                    <span
                                        className={s.balance}
                                    >
                                        {item.currency === "usd" ? "$" : "€"} {item.balance}
                                    </span>
                                </div>
                            ))}
                        </Flex>
                    </div>
                </Flex>
            </Spin>
        </div>
    );
}